import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.flat-map.js";
import "core-js/modules/esnext.iterator.map.js";
function m(o, ...p) {
  return p.flatMap((t) => typeof t == "string" ? t.split(" ") : []).map((t) => o[t]).filter(Boolean).join(" ");
}
export {
  m as default
};
